import script from "./OfflineBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./OfflineBanner.vue?vue&type=script&setup=true&lang=js"

import "./OfflineBanner.vue?vue&type=style&index=0&id=d18ca084&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d18ca084"]])

export default __exports__